import {useState} from "react";
import {Table, Modal} from 'antd';
import {Link, useParams} from "react-router-dom";

import PageHeading from "../../shared/containers/PageHeading";
import LiveSearch from "../../modules/LiveSearch";
import PageStatistics from "../../modules/PageStatistics";
import PageFilters from "../../modules/PageFilters";
import ClientCard from "../../modules/CLientCard";

import useTableData from "../../shared/hooks/useTableData";

import {columns} from "./table";
import stats from "./stats";

import {createGetById} from "../../shared/services/clients";

const MissionsByPersonPage = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({});

    const {id} = useParams();

    const getById = createGetById(id);

    const {
        statsVisible,
        filteredInfo,
        sortedInfo,
        data,
        loading,
        pagination,
        handleChange,
        resetFilters,
        resetSorters,
        handleSearch,
        toogleStatsVisible,
    } = useTableData({fetchData: getById});

    const showDetails = (id) => {
        setModalOpen(true);
        const element = data.hits.find(item => item.id === id);
        setModalContent(element);
    }

    const columnsConfig = [...columns];

    // columnsConfig[0].filteredValue = filteredInfo.userType || null;
    // columnsConfig[1].filteredValue = filteredInfo.status || null;
    //
    // columnsConfig[1].sortOrder = sortedInfo.columnKey === 'name' ? sortedInfo.order : null;
    // columnsConfig[2].sortOrder = sortedInfo.columnKey === 'email' ? sortedInfo.order : null;
    // columnsConfig[3].sortOrder = sortedInfo.columnKey === 'phoneNumber' ? sortedInfo.order : null;
    // columnsConfig[4].sortOrder = sortedInfo.columnKey === 'date' ? sortedInfo.order : null;

    columnsConfig[0].render = (text, record) => <span onClick={() => showDetails(record.id)}>{text}</span>;

    const {hits, ...statsValue} = data;
    console.log(hits)

    return (
        <>
            <PageHeading title="Related Missions" subtitle="See the missions related to Amalia Waller">
                <LiveSearch toogleStatsVisible={toogleStatsVisible} onChange={handleSearch} />
            </PageHeading>
            {statsVisible && <PageStatistics items={stats} values={statsValue}/>}
            <PageFilters resetFilters={resetFilters} resetSorters={resetSorters} />
            <Table columns={columnsConfig} dataSource={hits} loading={loading} pagination={pagination}
                   onChange={handleChange}/>
            <Modal visible={modalOpen} onCancel={() => setModalOpen(false)} footer={null}>
                <ClientCard {...modalContent} />
            </Modal>
        </>
    )
}

export default MissionsByPersonPage;
